<template>
  <div class="row justify-content-center">
    <div class="col-md-5">
      <h3 class="text-center" style="margin-bottom: 30px;">Crea DOG</h3>
      <b-form @submit.prevent="onFormSubmit">
        <div>
          <b-input-group prepend="Nome Cane" size="7" class="mb-4">
            <b-form-input aria-label="name" class="mx-3" v-model="dog.name" placeholder="" :formatter="formatter" required></b-form-input>
          </b-input-group>
          <b-input-group prepend="Razza" size="7" class="mb-4">
            <v-select label="breedName" class="mx-3" style="width: 198px; height: 34px;" :value="$store.myValue" :options="options" :reduce="breedName => breedName.selBreed" @input="feedBreed" placeholder="Seleziona--" required>
            </v-select>
          </b-input-group>
        </div>
        <div>
          <b-input-group prepend="Taglia / tipo di pelo" class="mb-4">
            <b-form-select aria-label="size" class="mx-3" style="max-width: 25%" v-model="dog.size" :options="sizeOptions" placeholder="Tg" required>
              <option v-for="(text, value) in sizeOptions" 
                :key="value"
                :value="text">
              </option>
            </b-form-select>
            <span style="vertical-align: middle">/</span>
            <b-form-select aria-label="hair" class="ml-3" style="max-width: 25%" v-model="dog.hair" :options="hairOptions" placeholder="pelo" required>
              <option v-for="(text, value) in hairOptions" 
                :key="value"
                :value="text">
              </option>
            </b-form-select>
          </b-input-group>
        </div>
        <div>
          <b-input-group prepend="Gruppo SELF" class="mb-4">
            <b-form-select aria-label="washpgm" class="mx-3" style="max-width: 25%" v-model="dog.washPgm" :options="washPgmOptions" placeholder="wash Pgm" required>
              <option v-for="(text, value) in washPgmOptions" 
                :key="value"
                :value="text">
              </option>
            </b-form-select>
            <b-form-radio-group
              v-model="dog.sex"
              :options="sexOptions"
              button-variant="outline-success"
              name="radio-btn-outline"
              buttons
              >
            </b-form-radio-group>
          </b-input-group>
        </div>
        <div>
          <b-input-group prepend="Nato/a il" size="7" class="mb-4">
            <b-form-datepicker aria-label="birthday" class="ml-3" v-model="dog.birthday" placeholder="" required></b-form-datepicker>
          </b-input-group>
        </div>
        <div>
          <b-input-group size="7" class="mb-4">
            <b-form-input aria-label="notes" type="text" v-model="dog.notes[0].note" placeholder="note"></b-form-input>
          </b-input-group>
        </div>
        <!-- <div>
          <b-input-group prepend="Taglia / pelo" size="7" class="mb-4">
            <b-form-input aria-label="size" class="mx-3" v-model="dog.size" placeholder=""  required></b-form-input>
            <span style="vertical-align: middle">/</span>
            <b-form-input aria-label="size" class="mx-3" v-model="dog.hair" placeholder=""  required></b-form-input>
          </b-input-group>
          <b-input-group prepend="Gruppo SELF" size="7" class="mb-4">
            <b-form-input aria-label="size" class="mx-3" v-model="dog.washPgm" placeholder=""  required></b-form-input>
          </b-input-group>
        </div>
        <div class="form-group">
          <b-form-datepicker v-model="dog.birthday" style="margin-right: 20px;" locale="it" placeholder="Data di nascita" required></b-form-datepicker>
          <b-form-group inline label="Sex">
            <b-form-radio-group
              v-model="dog.sex"
              :options="sexOptions"
              name="radio-inline"
            ></b-form-radio-group>
          </b-form-group>
          <select type="text" class="form-control" v-model="dog.alive"
            required placeholder="Stato">
            <option value=true>vivo</option>
            <option value=false>morto</option>
          </select>
          <b-form-group label="Stato" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="selectedStatus"
              :options="statusOptions"
              :aria-describedby="ariaDescribedby"
              name="radio-inline"
            ></b-form-radio-group
          </b-form-group>>
        </div>
        <div class="form-group">
          <input type="text" class="form-control" v-model="dog.notes[0].note"   placeholder="Note">
        </div> -->
        <p class="error">{{ error.message }}</p>
        <div class="form-group">
          <button class="btn btn-primary btn-block">SALVA</button>
        </div>
        <p class="success">{{ success.message }}</p>
      </b-form>

      <b-modal ref="my-modal" centered hide-footer title="Cane REGISTRATO">
        <div class="d-block text-center">
          <h3>Dog <strong>{{ dog.name }}</strong> creato.
            <br />CONTINUA per creare un ABBONAMENTO -->
          </h3>
        </div>
        <b-button class="mt-3" variant="outline-success" block @click= "addSubs">CONTINUA</b-button>
        <!-- <b-button class="mt-2" variant="outline-warning" block @click="toggleModal">
           CHIUDI
        </b-button> -->
        <b-button class="mt-2" variant="outline-warning" block @click="hideModal">
           CHIUDI
        </b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
   import { db } from '../../firebase/config.js';
   import { cardData } from '../../interfaces/CardData';
   import { mapGetters, mapMutations } from 'vuex';

   export default {
      data() {
         return {
            selectedBreed: {},
            options: [],
            dog: {
               name: '',
               breedRef: '',
               breedName: '',
               size: 0,
               hair: 0,
               washPgm: '',
               birthday: '',
               sex: '',
               alive: true,
               notes: [{
                  note: null,
                  date: null,
               }],
            },
            sizeOptions: [
              { text: 'XS', value: 1 },
              { text: 'S', value: 2 },
              { text: 'M', value: 3 },
              { text: 'L', value: 4 },
              { text: 'XL', value: 5 },
              { text: 'XXL', value: 6 },
            ],
            hairOptions: [
              { text: 'S', value: 1 },
              { text: 'M', value: 2 },
              { text: 'L', value: 3 }
            ],
            washPgmOptions: [
              { text: 'XS/S', value: '11' },
              { text: 'XS/M', value: '12' },
              { text: 'XS/L', value: '13' },
              { text: 'S/S', value: '21' },
              { text: 'S/M', value: '22' },
              { text: 'S/L', value: '23' },
              { text: 'M/S', value: '31' },
              { text: 'M/M', value: '32' },
              { text: 'M/L', value: '33' },
              { text: 'L/S', value: '41' },
              { text: 'L/M', value: '42' },
              { text: 'L/L', value: '43' },
              { text: 'XL/S', value: '51' },
              { text: 'XL/M', value: '52' },
              { text: 'XL/L', value: '53' },
              { text: 'XXL/S', value: '61' },
              { text: 'XXL/M', value: '62' },
              { text: 'XXL/L', value: '63' },
            ],
            sexOptions: [
              { text: 'Maschio', value: 'M' },
              { text: 'Femmina', value: 'F' }
            ],
            /*selectedStatus: true,
            statusOptions: [
               { text: 'vivo', value: true },
               { text: 'morto', value: false }
            ],*/
            card: cardData,
            error: {
               value: null,
               message: ''
            },
            success: {
               value: null,
               message: ''
            }
         }
      },
      created() {
        this.options = []
        db.collection('breeds').get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.options.push({
              breedName: doc.data().name,
              selBreed: {
                id: doc.id,
                data: doc.data(),
              }
            });
          });
          console.log("options => ", this.options);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
      },
      methods: {  
        formatter(value) {
          return value.toUpperCase()
        },
         showModal() {
            this.$refs['my-modal'].show()
         },
         hideModal() {
            console.log('fase2-DOG finita')
            this.$refs['my-modal'].hide()
            this.$router.push({name:'add_subs'})
            //this.$router.push({name:'user_detail'})
         },
         toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            //this.$refs['my-modal'].toggle('#toggle-btn')
            this.$refs['my-modal'].hide()
            this.$router.push({ name:'user_detail' })
         },
         addSubs() {
            /*this.card = this.sel_card;
            console.log('card ->', this.card);
            this.card.data.subsItem1.dogRef = this.sel_dog.id
            console.log('card ->', this.card);
            this.set_sel_card(this.card.data);*/
            //db.collection('cards').doc(this.card.uid).set(this.card.data);
            this.$refs['my-modal'].hide()
            this.$router.push({ name:'add_subs' })
         },
         feedBreed(value) {
            event.preventDefault();
            console.log("selectedBreedData -> ", value);
            console.log(event.target.value);
            this.dog.breedRef = value.id;
            this.dog.breedName = value.data.name;
            this.dog.size = value.data.size;
            this.dog.hair = value.data.hair;
            this.dog.washPgm = value.data.washPgm.toString();
         },   
         onFormSubmit(event) {
            event.preventDefault();
            if(this.dog.notes[0].note !== null) {
               this.dog.notes[0].date = new Date().toLocaleString()
            }
            const userRef = db.collection('users').doc(this.sel_user.data.id);
            console.log('userRef ->', userRef.path);
            db.doc(userRef.path).collection('dogs').add(this.dog)
            .then((doc) => {
               //Save dog data into the state
               console.log('doc-path ->', doc.path);
               db.doc(doc.path).get()
               .then((doc) => {
                  console.log('doc-DOG ->', doc.data());
                  this.set_sel_dog({id: doc.id, data: doc.data()});
                  //Display success
                  console.log('sel_dog ->', this.sel_dog);
                  this.showModal();
               });
            })
            .catch((err) => {
               //Display error
               console.log(err.message, err)
               this.showModal();
            });
         },
         ...mapMutations({
            set_sel_dog: 'SET_SEL_DOG', // map `this.set_sel_dog()` to `this.$store.commit('SET_SEL_DOG')`
            set_sel_card: 'SET_SEL_CARD'
         }),
      },
      computed: {
        ...mapGetters({
          // map `this.sel_user` to `this.$store.getters._user`
          sel_user: "_user",
          sel_dog: "_dog",
          sel_card: "_card"
        }),
      },
   };
</script>

<style>
   .btn-primary {
      background: #bad300;
      border: #bad000;
   }
   .material-icons {
      font-size: 24px;
      margin-right: 10px;
      color: #ccc;
      cursor: pointer;
   }
   .material-icons:hover {
      color: #777;
   }
   .success {
      color: $success;
   }
</style>